import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
    authority: process.env.REACT_APP_AZURE_AD_AUTHORITY, // Choose SUSI as your default authority.
    redirectUri: process.env.REACT_APP_AZURE_AD_REDIRECT_URL, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    knownAuthorities: [process.env.REACT_APP_AZURE_AD_AUTHORITY_DOMIAN], // Mark your B2C tenant's domain as trusted.
    postLogoutRedirectUri: process.env.REACT_APP_AZURE_AD_LOGOUT_REDIRECT_URL,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    secureCookies: true,
    claimsBasedCachingEnabled: true,
  },
  system: {
    allowNativeBroker: false, // Disables native brokering support
  },
};
console.log("msalConfig >> ", msalConfig)
export const loginRequest = {
  scopes: ['openid', 'offline_access'],
  loginHint: '',
};

export const redirectRequest = {
  scopes: ['User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);